import PassportRecordRequirementItem from "./PassportRecordRequirementItem";

export default PassportRecordRequirementItem;